import React from 'react'
// Ant Design
import { Flex } from 'antd'
// Layout
import { Sidebar } from '../Layout/Sidebar'
// Fragments
import { Header } from '../Fragments/New/Header'
import { Content } from '../Fragments/New/Content'
// i18
import { useTranslation } from 'react-i18next'

export const New = () => {
    const { t } = useTranslation(["translation"]);

    return (
        <Flex>
            <Sidebar />

            <Flex vertical style={{ width: "calc(100% - 250px)", height: "100vh", padding: "0 15px" }}>
                <Header t={t} />
                <Content t={t} />
            </Flex>
        </Flex>
    )
}
